import styled from 'styled-components';

export const Container = styled.div`
  top: 0px;
  left: 0px;
  width: 100%;
  margin: auto;
  display: flex;
  position: relative;
  flex-direction: column;
  box-sizing: border-box;
  max-width: 1300px;
`;
